export const Unicode = {
  CommandKey: String.fromCharCode(8984),
  HeavyCheckMark: String.fromCharCode(10004),
  Space: String.fromCharCode(32),
};
